import { AnimatedSection, DarkCard, DarkMeshSection } from '@denqfabrik/landing-ui';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { getRoutesForLang } from '../../i18n/routes';

const STEP_ICONS = ['\uD83D\uDCAC', '\uD83D\uDD27', '\uD83D\uDCCB'];

export default function HowItWorksSection() {
  const { t, lang } = useTranslation();
  const { label, heading, headingHighlight, intro, steps, linkText, linkButton } = t.howItWorks;
  const routes = getRoutesForLang(lang);
  const detailHref = `/${lang}${routes['how-it-works']}`;

  return (
    <DarkMeshSection id="how-it-works">
      {/* Heading */}
      <AnimatedSection>
        <div className="mx-auto mb-6 max-w-3xl text-center">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-teal-400">
            {label}
          </p>
          <h2 className="font-display text-[clamp(2.3rem,4.6vw,4.8rem)] font-medium leading-[1.08] tracking-[-0.028em] text-[#cfe0ff]">
            {heading}{' '}
            <span className="bg-[linear-gradient(120deg,#4f8dff_10%,#62c7ff_62%,#61e3ce_100%)] bg-clip-text text-transparent">
              {headingHighlight}
            </span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[clamp(1.05rem,1.35vw,1.35rem)] leading-[1.4] text-[var(--df-text-mid)]">
            {intro}
          </p>
        </div>
      </AnimatedSection>

      {/* Steps */}
      <div className="mt-12 grid grid-cols-1 items-stretch gap-6 md:grid-cols-3">
        {steps.map((step, i) => (
          <AnimatedSection key={step.number} delay={i * 120} className="h-full">
            <DarkCard className="h-full">
              <div className="flex h-full flex-col items-start p-2">
                <span className="mb-4 text-4xl">{STEP_ICONS[i]}</span>
                <span className="text-sm font-semibold text-teal-400">{step.number}</span>
                <h3 className="mt-2 text-xl font-medium tracking-tight text-[#d5e4ff]">
                  {step.title}
                </h3>
                <p className="mt-3 text-[0.94rem] leading-relaxed text-[var(--df-text-mid)]">
                  {step.description}
                </p>
              </div>
            </DarkCard>
          </AnimatedSection>
        ))}
      </div>

      {/* CTA */}
      <AnimatedSection delay={400}>
        <div className="mt-12 flex flex-col items-center gap-4 text-center">
          <h5 className="text-[1.15rem] font-semibold text-[var(--df-text-mid)]">{linkText}</h5>
          <Link
            to={detailHref}
            className="inline-flex items-center gap-2 rounded-2xl bg-sky-100 px-6 py-3.5 text-base font-medium text-slate-900 transition-all duration-300 hover:bg-white"
          >
            {linkButton}
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12H19M12 5L19 12L12 19" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </AnimatedSection>
    </DarkMeshSection>
  );
}
